import * as React from 'react'
import {useParams, Link} from 'react-router-dom'
import axiosClient from '../utils/API'
import axios from 'axios'

import banner from '../assets/store/banner.jpg'
import {Loader, LoaderHeader} from './loaders'

const SingleStore = (props) => {
    const params = useParams()
    const {id, slug} = params
    const [products, setProducs] = React.useState([])
    const [storeInfo, setStoreInfo] = React.useState({})

    const [subCategories, setSubCategories] = React.useState([])
    const [categories, setCategories] = React.useState([])

    const [urlRequest ,setUrlRequest] = React.useState('')
    
    const [errorRequest, setErrorRequest] = React.useState(false)
    const [notProductFound, setNotProductFound] = React.useState(false)
    
    async function getProductsByprovider() {
        try {
            const response = await axiosClient.get(
                `/products?filter=[{"method":"where","parameters":["provider_id",${id}]},{"method":"with","parameters":["batches","batches.provider","batches.distributor","campaing"]}]`,
              )
            setProducs(response.data)
        } catch (error) {
            console.log(error);
            setErrorRequest(true)
        }
    }
    async function getProviderInfo() {
        try {
            const response = await axiosClient.get(`/providers/${slug}/${id}`)
            setStoreInfo(response.data)
            console.log(response.data);
            if(response.data.categories.length > 0) {
                setCategories(response.data.categories)
            } else {
                setCategories(response.data.aeromall_categories)
            }
            /*if(response.data.aeromall_categories.length > 0) {
                setCategories(response.data.aeromall_categories)
            } else {
                setCategories(response.data.categories)
            }*/
        } catch (error) {
            console.log(error);
            
        }
    }

    async function getNewProductsByFilter() {
        setProducs([])
        setErrorRequest(false)
        setNotProductFound(false)
        console.log(urlRequest);
        try {
            const response = await axios.get(urlRequest)
            console.log(response.data);
            if(response.data.products.length > 0) {
                setProducs(response.data.products)   
            } else {
                setNotProductFound(true)
            }
        } catch (error) {
            console.log(error);
            setErrorRequest(true)
        }
    }

    const [showSub, setShowSub] = React.useState([])
    function handleShowSub(i) {
        if(showSub.includes(i)) {
            setShowSub(showSub.filter(op => op !== i))
        } else {
            setShowSub([...showSub, i])
        }
    }
   
    React.useEffect(() => {
        if(props.location.state) {
            setUrlRequest(props.location.state)
        } 
    }, [props])

    React.useEffect(() => {
        getProviderInfo()
        if(!props.location.state) {
            getProductsByprovider()
        } 
    }, [id, slug, props])

    React.useEffect(() => {
        if(urlRequest !== '') {
            getNewProductsByFilter()
        }
    }, [urlRequest])
    return ( 
        <main>
            <section className="store_unik_header">
                <img className="banner_unik" src={storeInfo.logo ? storeInfo.logo : banner} alt=""/>
                <div className="store_unik_header_info">
                    {Object.keys(storeInfo).length === 0 ? <LoaderHeader /> : <Header storeInfo={storeInfo} /> }                   
                </div>
            </section>
            <section className="store_unik_body">
                    <div className="store_unik_body_categories">
                        {Object.keys(storeInfo).length === 0 ? null : (
                            categories.length === 0 ? <div><span>Este proveedor no dispone de categorías</span></div> : (
                                <div className="store_unik_categories">
                                    <h5>Categorías</h5>
                                    {categories.map((category, index, categories) => {
                                        return (
                                            <div className="store_unik_categories_mark">
                                                <h6>
                                                    <strong onClick={() => setUrlRequest(category.url)}>{category.name}</strong>
                                                    <div>
                                                        {
                                                            showSub.includes(index) 
                                                            ? <i class="fas fa-chevron-right" onClick={() => handleShowSub(index)}></i>
                                                            : <i class="fas fa-chevron-down" onClick={() => handleShowSub(index)}></i>
                                                        }
                                                    </div>
                                                </h6>
                                                {!showSub.includes(index) ? (
                                                    <div className="store_unik_categories_options">
                                                        {categories[index].subcategories?.map(subcategory => (
                                                            <span onClick={() => setUrlRequest(subcategory.url)}>{subcategory.name}</span>
                                                            ))}
                                                    </div>
                                                ): null}
                                            </div>
                                        )
                                    })}                                    
                                </div>
                            )
                        )}
                    </div>
                    <div className="store_unik_body_products">
                        {notProductFound ? <span className="not-product-found-unik">No se encontraron productos</span> : 
                            errorRequest ? <span className="error-server-unik">Hubo un problema con el servidor, intenta de nuevo</span> : 
                            products.length === 0 ? <Loader /> : (
                                <>
                                    <div className="store_unik_body_select">
                                        {/* <select name="" id="">
                                            <option value="">Selecionar subcategoría</option>
                                        </select> */}
                                    </div>  
                                    <div className="store_unik_body_products">
                                        {products.map(product => ( <Card product={product} key={product.id} /> ))}
                                    </div>
                                </>                  
                            )
                        }
                    </div>
                
            </section>
        </main>
     );
}
 
export default SingleStore;

const Card  = ({product}) => {
    return ( 
        <Link to={`/productos/${product.aeromall_categories && product.aeromall_categories.length > 0 ? product.aeromall_categories[0]?.slug : 'general'}/${product.slug}/${product.id}`}>
            <div className="store_unik_body_product_card">
                {/* <span>{product?.batches[0].provider.name}</span> */}
                <h5>{product?.name}</h5>
                <div className="store_unik_body_product_card_img">
                    <img src={product?.image_url} alt=""/>
                </div>
                <div className="store_unik_body_product_card_body">
                    {product.promo_price ? (
                        <div className="discount_amount_promo_price">
                            <strong>${product.promo_price}</strong>
                            <span>{product?.batches[0]?.unit_price}</span>
                        </div>
                    ): <strong>${product?.batches[0]?.unit_price}</strong>}
                </div>
                {product.batches[0]?.stock === 0 ? (
                    <div className="none_stock_alert_product_item_home">
                        <span>agotado</span>
                    </div>
                ) : null}
                {product.promo_price ? (
                    <div className="promo_price_show">
                        <span style={{color: 'white'}}>Promoción</span>
                    </div>
                ): null}
            </div>
        </Link>
     );
}

const Header = ({storeInfo}) => {
    return ( 
        <>
            <div className="store_unik_header_content">
                <div>
                    <img src={storeInfo.logo} alt=""/>
                </div>
                <div className="store_unik_header_content_store">
                    <h4>{storeInfo.name}</h4>
                    <h5>{storeInfo.description}</h5>
                </div>
            </div>
        </>
     );
}
 
